// state
import { IAppState, initialAppState } from "@store/state/App";

// actions
import { IAppAction, AppActionTypes } from "@store/actions/App";

// helpers
import { createDeepCopy } from "@utils/index";

// Reducer to handle app state and actions
export const appReducer = (state: IAppState = initialAppState, action: IAppAction): IAppState => {
    switch (action.type) {
        case AppActionTypes.SET_PAGE_TITLE:
        case AppActionTypes.SET_START_LOADING:
        case AppActionTypes.SET_STOP_LOADING:
        case AppActionTypes.SHOW_ALERT_MESSAGE:
        case AppActionTypes.HIDE_ALERT_MESSAGE:
        case AppActionTypes.SET_SIDE_MENU_OPEN:
        case AppActionTypes.SET_SIDE_MENU_CLOSE:
        case AppActionTypes.SET_STAGE:
            // createDeepCopy is used to ensure immutability - creates a completely new object
            // with all nested properties copied, preventing any accidental mutations of the original state
            return createDeepCopy({
                ...state,
                ...action.payload,
            });
        case AppActionTypes.TOGGLE_MENU_CLOSE:
            // createDeepCopy ensures immutable state updates even for nested state properties
            return createDeepCopy({
                ...state,
                isSideMenuOpen: !state.isSideMenuOpen,
            });

        default:
            return state;
    }
};
